import React from "react";
const PixelGridContext = React.createContext();
export default PixelGridContext;
